module.exports = __webpack_public_path__ + "static/media/Amy Knobbs.f98f1da5.png";